import { collection, addDoc } from 'firebase/firestore';
import { dataBase } from './firebaseConfig';

export const addData = async <T>(collectionName: string, item: T) => {
  return await addDoc(collection(dataBase, collectionName), item);
};
